export class AspectType {
    static readonly PREFIX = 'http://www.honeywell.com/models/core/propertyroles/1.0';
    static readonly ELEMENT_TYPE = AspectType.PREFIX + '#hasElementType';
    static readonly MEASURE_TYPE = AspectType.PREFIX + '#hasMeasureType';
    static readonly MATERIAL_TYPE = AspectType.PREFIX + '#hasMaterialType';
}
